import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { grey } from "@mui/material/colors";

const getDesignTokens = (mode) => ({
  palette: {
    mode,
    primary: {
      main: "#28527a",
      light: "#3a6d9f",
      dark: "#1f3e5c",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#0072b5",
      light: "#3390c6",
      dark: "#005487",
      contrastText: "#ffffff",
    },
    error: {
      main: "#ef4444",
    },
    warning: {
      main: "#f59e0b",
    },
    info: {
      main: "#0ea5e9",
    },
    success: {
      main: "#22c55e",
    },
    grey,
    divider: mode === "light" ? "#e2e8f0" : "#1f2937",
    background: {
      default: mode === "light" ? "#f8fafc" : "#0b1220",
      paper: mode === "light" ? "#ffffff" : "#0f172a",
    },
    text: {
      primary: mode === "light" ? "#0f172a" : "#e2e8f0",
      secondary: mode === "light" ? "#334155" : "#cbd5e1",
      disabled: mode === "light" ? "#94a3b8" : "#64748b",
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: [
      "Inter",
      "Roboto",
      "Segoe UI",
      "Helvetica",
      "Arial",
      "sans-serif",
    ].join(","),
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiAppBar: {
      defaultProps: { square: true },
      styleOverrides: {
        root: { borderRadius: 0 },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        html: { height: "100%" },
        body: {
          height: "100%",
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        },
        "#root": { height: "100%" },
        "*": { boxSizing: "border-box" },
        "*::before": { boxSizing: "border-box" },
        "*::after": { boxSizing: "border-box" },
        "::-webkit-scrollbar": { width: 10, height: 10 },
        "::-webkit-scrollbar-thumb": {
          backgroundColor: mode === "light" ? "#cbd5e1" : "#334155",
          borderRadius: 8,
        },
        "::-webkit-scrollbar-track": {
          backgroundColor: mode === "light" ? "#f1f5f9" : "#0b1220",
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 12, textTransform: "none", fontWeight: 600 },
        sizeLarge: { paddingTop: 12, paddingBottom: 12 },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { borderRadius: 8, fontSize: "0.85rem" },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
  },
});

export const createAppTheme = (mode = "light") =>
  responsiveFontSizes(createTheme(getDesignTokens(mode)));
export const mainTheme = createAppTheme("light");
